"use client";

import type React from "react";

import { cn } from "@ui/lib/utils";
import { XIcon } from "lucide-react";

import { closePanel } from "../state/actions";
import { useSoundboard } from "../state/reducer";

export const Panel = ({
  children,
  footer,
  title,
  subtitle,
  border = true,
}: {
  border?: boolean;
  children: React.ReactNode;
  footer?: React.ReactNode;
  subtitle: string;
  title: string;
}) => {
  const { dispatch } = useSoundboard();
  return (
    <div className={cn("flex w-full flex-col gap-4 rounded-md bg-default", border && "border")}>
      <div className='flex items-center gap-4 border-b border-default p-16'>
        <p className='font-soundboard f-ui-04 rounded-sm bg-inverse p-4 px-6 text-inverse'>{title}</p>
        <p className='font-soundboard f-ui-04 rounded-sm bg-inverse p-4 px-6 text-inverse'>{subtitle}</p>
        <button
          className='font-soundboard f-ui-04 ml-auto flex h-20 w-20 items-center justify-center rounded-sm border text-light'
          onClick={() => dispatch(closePanel())}
        >
          <XIcon size={12} />
        </button>
      </div>
      <div className='flex-1 overflow-y-auto p-16'>{children}</div>
      {footer && <div className='border-t border-default'>{footer}</div>}
    </div>
  );
};
